import * as React from 'react'
import { Typography } from '@lacedltd/laced-components'
import { useLocale, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import * as S from './ResetEmailSent.styles'

const ResetEmailSent: React.FC = () => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  return (
    <>
      <Typography.Heading as="h1">
        {t('react_components.passwords.check_email')}
      </Typography.Heading>
      <S.Paragraph as="p" variant="body">
        {t('react_components.passwords.reset_instructions')}
      </S.Paragraph>

      <S.ButtonLink className={`btn btn--primary`} href={localiseUrl('/')}>
        {t('react_components.passwords.go_home')}
      </S.ButtonLink>
    </>
  )
}

export default withTranslations(ResetEmailSent)
